import { SurveyEditPageStep } from "@/pages/talent/surveys/edit/survey-edit.ts";
import { ApiSurveyEdit } from "@/types/survey.types.ts";
import { Avatar, DotSeparator, Stack, Text } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";

const surveySteps = [
  SurveyEditPageStep.details,
  SurveyEditPageStep.questions,
  SurveyEditPageStep.launch,
  SurveyEditPageStep.notifications,
];

interface SurveyEditTitleSlotProps {
  step: SurveyEditPageStep;
  survey?: ApiSurveyEdit;
}

export const SurveyEditTitleSlot = ({ step, survey }: SurveyEditTitleSlotProps) => {
  const { t } = useTranslation();
  const stepIndex = surveySteps.indexOf(step);

  return (
    <DotSeparator className={"inline-flex"}>
      <Text className={"font-semibold"}>{t("surveys:survey")}</Text>
      {stepIndex > 0 && survey && (
        <Stack gap={"sm"} direction={"horizontal"} items={"center"}>
          {survey.emoji && <Avatar emoji={survey.emoji} size={"sm"} />}
          <Text className={"font-semibold"}>{survey.title}</Text>
        </Stack>
      )}
      <Text>
        {t("core:step_of", {
          currentStep: stepIndex + 1,
          countSteps: surveySteps.length,
        })}
      </Text>
    </DotSeparator>
  );
};
